import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FormatIndentDecreaseIcon(props: IconProps) {
    return <Icon {...props} iconKey={"format_indent_decrease"}/>
}
